import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import * as anime from 'animejs/lib/anime';

@Directive({
  selector: '[textAppear]'
})
export class TextAppearDirective implements OnInit {
  @Input() delay?: number = 500;

  constructor(private el: ElementRef) {
  }

  ngOnInit() {
    this.el.nativeElement.style.opacity = 0;
    anime({
      targets: [this.el.nativeElement],
      translateX: [-2000, 0], // from 100 to 250
      delay: this.delay,
      direction: 'alternate',
      loop: false,
      opacity: 1
    });
  }
}
